import { useEffect } from 'react';
import { useLocation } from 'react-router-dom';
import NProgress from 'nprogress';
import 'nprogress/nprogress.css';

// Configure NProgress
NProgress.configure({ 
    showSpinner: false,
    trickleSpeed: 200,
    minimum: 0.08
});

const ProgressHandler = () => {
  const location = useLocation();

  useEffect(() => {
    // Start progress on location change
    NProgress.start();

    // Finish progress after a short delay to simulate loading
    // or when the component update is complete
    const timer = setTimeout(() => {
      NProgress.done();
    }, 100);

    return () => {
      clearTimeout(timer);
      NProgress.done();
    };
  }, [location]);

  return null;
};

export default ProgressHandler;
